import React, { useEffect, useState } from "react";

import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { getDropdownCountryList } from "../../../../service/rak-beneficiary-service";

const RechargeBeneficiaryFilter = ({
  show = false,
  onHide,
  saveButtonClicked,
  type,
  setType,
  country,
  setCountry,
}) => {
  // const [type, setType] = useState([]);
  // const [country, setCountry] = useState([]);
  const [typeLength, setTypeLength] = useState("");
  const [countryLength, setCountryLength] = useState("");
  const [typeList, setTypeList] = useState([
    { value: "Local", label: "Local" },
    { value: "International", label: "International" },
  ]);
  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    getDropdownCountryListDD(); // TODO - ENABLE IN PRODUCTION
  }, []);

  const getDropdownCountryListDD = () => {
    getDropdownCountryList("ALL")
      .then((getDropdownCountryListRes) => {
        console.log({ getDropdownCountryListRes });
        if (getDropdownCountryListRes && getDropdownCountryListRes.data) {
          let data = getDropdownCountryListRes.data.map((element) => {
            element.label = element.name || "";
            element.value = element.code || "";
            return element;
          });
          setCountryList(data);
        }
      })
      .catch((getDropdownCountryListErr) => {
        console.log({ getDropdownCountryListErr });
        setCountryList([]);
      });
  };
  return (
    <>
      <Modal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rak-beneficiary-modal"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Type"
              onChange={(data) => {
                console.log("Selected Type", data);
                setType(data);
                setTypeLength((data && data.length) || 0);
              }}
              options={typeList}
              value={type}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Country"
              onChange={(data) => {
                setCountry(data);
                setCountryLength((data && data.length) || 0);
              }}
              options={countryList}
              value={country}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              let req = {};
              req.searchType = type;
              req.searchCountry = country;
              req.typeLength = type.length;
              req.countryLength = country.length;
              req.totalLength = req.typeLength + req.countryLength;
              saveButtonClicked(req);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RechargeBeneficiaryFilter;
